import styled, { css } from 'styled-components'
import colors from '../../configuration/colors'
import { H2, P2, ErrorTypography } from '../../components/styled/typography/typography'

export const H2UserDetail = styled(H2)`
  display: inline-block;
  margin-left: 20px;
  padding: 26px 0;
  vertical-align: top;
`

export const P2ImageSelection = styled(P2)`
  padding-top: 45px;
`

export const AccountError = styled(ErrorTypography)`
  display: inline-block;
  width: 100%;
  max-width: 500px;
  text-align: left;
  color: ${colors.crimson};
  font-size: 15px;
  font-weight: 500;
`

export const LoginForm = styled.form`
  padding: 0;
  
  ${props => props.error && css`
    margin-top: 25px;
  `}
`
